module.exports = __webpack_public_path__ + "twilio-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/twilio-logo.png
// module id = 1271
// module chunks = 74